import type { CheckoutThemedButton, ThemedButton } from '@trmediaab/zebra';

const button: ThemedButton & CheckoutThemedButton = {
  common: {
    justifyContent: 'center',
    fontWeight: 'semiBold',
  },
  shape: {
    rounded: {
      common: {
        borderRadius: '3px',
      },
      variants: {
        default: {
          height: 'buttonHeights.xlarge',
          fontSize: 'base',
          px: 3,
        },
      },
    },
  },
  palette: {
    primary: {
      bg: 'link.primary',
      color: 'white',
      '&:hover:not(:disabled), &:focus-visible': {
        bg: 'link.active',
      },
    },
    secondary: {
      bg: 'greys.0',
      color: 'link.primary',
      '&:hover:not(:disabled), &:focus-visible': {
        color: 'link.active',
      },
    },
  },
  disabled: {
    default: {
      opacity: '0.3',
    },
  },
  combinations: {
    checkoutPrimary: {
      shape: 'rounded',
      size: 'default',
      palette: 'primary',
    },
    checkoutSecondary: {
      shape: 'rounded',
      size: 'default',
      palette: 'secondary',
    },
    // TODO
    offersPrimary: {
      shape: 'rounded',
      size: 'default',
      palette: 'primary',
    },
    // TODO
    offersSecondary: {
      shape: 'rounded',
      size: 'default',
      palette: 'primary',
    },
    // TODO
    offersTertiary: {
      shape: 'rounded',
      size: 'default',
      palette: 'primary',
    },
  },
};

export default button;
